import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TBihinzaikoInfoGetRes,
  TBihinzaikoListGetReq,
  TBihinzaikoRegisterPostReq,
  TBihinzaikoUkeireRegisterPutReq,
  TBihinzaikoHaraidasiRegisterPostReq,
  TBihinzaikoRirekiListGetReq,
  TBihinzaikoRirekiInfoGetRes,
  TBihinzaikoDeleteReq,
} from "./TBihinzaiko"

/**
 * 備品在庫に対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class BihinzaikoService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TMenuInfoGetReq} params
   * @memberof bihinzaikoService
   */
  getList = async (params: TBihinzaikoListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TBihinzaikoInfoGetRes[]>> =
        await this.getInner(`/purchase/bihinzaiko`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 備品在庫 単体削除
   *
   * @param {TBihinzaikoDeleteReq} data
   * @memberof bihinzaikoService
   */
  bihinDelete = async (
    id: string,
    data: TBihinzaikoDeleteReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `purchase/bihinzaiko/del/${id}`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 検索取得
   *
   * @param {TBihinzaikoRirekiListGetReq} params
   * @memberof bihinzaikoService
   */
  getRirekiList = async (params: TBihinzaikoRirekiListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TBihinzaikoRirekiInfoGetRes[]>> =
        await this.getInner(`/purchase/bihinzaiko/rireki`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体取得
   *
   * @param {TBihinzaikoInfoGetReq} params
   * @memberof bihinzaikoService
   */
  get = async (id: string | number, signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TBihinzaikoInfoGetRes>> =
        await this.getInner(`/purchase/bihinzaiko/uke/${id}`, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体登録(受入)
   *
   * @param {TBihinzaikoInfoGetReq} data
   * @memberof bihinzaikoService
   */
  postUkeire = async (
    data: TBihinzaikoRegisterPostReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `purchase/bihinzaiko/uke`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新（受入）
   *
   * @param {TBihinzaikoUkeireRegisterPutReq} data
   * @memberof bihinzaikoService
   */
  putUkeire = async (
    id: string,
    data: TBihinzaikoUkeireRegisterPutReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `purchase/bihinzaiko/uke/${id}`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新（払出）
   *
   * @param {TKyotenPostReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof KyotenService
   */
  putHaraidasi = async (
    id: string,
    data: TBihinzaikoHaraidasiRegisterPostReq,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `purchase/bihinzaiko/harai/${id}`,
        data,
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
